import React, { useEffect, useState } from 'react';
import store from 'store';
import { useDispatch, useSelector } from 'react-redux';
import CustomTable from 'components/CustomTable';
import CustomButton from 'components/CustomInput/Button/index';
import PageSize from 'components/CustomTable/PageSize';
import { DELETE_REVIEW_PANEL_BUY_ID, GET_REVIEW_PANEL_LIST } from 'store/key';
import PanelAddDialog from './PanelAddDialog';
import CustomPagination from 'components/CustomPagination';
import useReviewPanel from './useReviewPanel';
import useDialog from 'components/ConfirmDialog/useDialog';
import {DELETED_REVIEW_PANEL} from 'utility/frontendMessage';
const ReviewPanel = (props) => {
    const dispatch = useDispatch();
    const showDialog = useDialog();
    const { reviewPanelTotal } = useSelector((state) => state.reviewPanel);
    const { rows, columns } = useReviewPanel();
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    // const [sort, setSort] = useState('createDtm');
    // const [isDesc, setIsDesc] = useState(true);
    const [openPopup, setOpenPopup] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isLoading, setIsLoading] = useState(false);


    useEffect(() => {
        getReviewPanelList(page, pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const getReviewPanelList = (newPage, newPageSize, newSort, newIsDesc) => {
        setIsLoading(true);
        const params = {
            page: newPage ?? page,
            pageSize: newPageSize ?? pageSize,
            // sort: newSort ?? sort,
            // isDesc: newIsDesc ?? isDesc,
        };

        dispatch({
            type: GET_REVIEW_PANEL_LIST,
            payload: {
                params,
                callback: (length) => {
                    if(length===0&&page!==1){
                        getReviewPanelList(page-1, pageSize)
                        setPage(page-1)
                    }
                    setIsLoading(false)
                }
            },
        });
    };
    const changePage = (value) => {
        setPage(value);
        getReviewPanelList(value);
    };

    const handleCreate = () => {
        setSelectedRow(null);
        setOpenPopup(true);
    };

    const handleEdit = (row) => {
        setSelectedRow(row);
        setOpenPopup(true);
    };

    const deleteRow = (row) => {
        store.dispatch({
            type: DELETE_REVIEW_PANEL_BUY_ID,
            payload: {
                row,
                callback: () => {
                    getReviewPanelList(page, pageSize)
                    showDialog({
                        description: DELETED_REVIEW_PANEL,
                        disableCancelButton: true,
                    });
                }
            },
        });
    };

    return (
        <div style={{ padding: 15 }}>
            {openPopup && <PanelAddDialog isShow={openPopup} onCancel={() => setOpenPopup(false)} data={selectedRow} refleshReviewPaneList={() => getReviewPanelList(page, pageSize)} />}
            <div style={{ display: 'flex', alignItems: 'center', width: 741,justifyContent:'space-between'  }}>

                <CustomButton onClick={handleCreate}>Create</CustomButton>
                <PageSize
                    label={'Page Size'}
                    value={pageSize}
                    onChange={(value) => {
                        setPageSize(value)
                        getReviewPanelList(page, value);
                    }}
                />
            </div>
            <div style={{ marginTop: 20,width:741 }}>
                <CustomTable
                    isDeleteAllow={true}
                    isEditAllow={true}
                    onEdit={handleEdit}
                    onDelete={deleteRow}
                    columns={columns}
                    rows={rows}
                    // parentWidth={741}
                    skipMaxHeight={false}
                    allowResize
                    loading={isLoading}
                    // fullWidthTable={false}
                />
            </div>

            <div style={{ marginTop: 20, width: 741 }}>
                <CustomPagination page={page} pageSize={pageSize} total={reviewPanelTotal} onPageChange={changePage} />
            </div>
        </div>
    );
};

export default ReviewPanel;
